/* Copyright Verge Technologies 2018
 * @file servicesAndSupport.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React from 'react';

// Components
import ServiceCard from '../ServiceCards/serviceCard';

const services = require('./servicesAndSupport.json');

const ServicesAndSupport = () => {
  return (
    <div>
      <div className="heading-container">
        <h1>Services & Support</h1>
        <hr />
      </div>
      <div className="support-container">
        <ul>
          {services.map((service) => {
            return (
              <ServiceCard title={service.title} iconImage={service.iconImage} address={service.address} key={service.id} />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ServicesAndSupport;



// WEBPACK FOOTER //
// ./src/components/ServicesAndSupport/servicesAndSupport.js